import { render, staticRenderFns } from "./AgroFileUpload.vue?vue&type=template&id=ef5e82ca&scoped=true&"
import script from "./AgroFileUpload.vue?vue&type=script&lang=ts&"
export * from "./AgroFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./agro-file-upload.scss?vue&type=style&index=0&id=ef5e82ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5e82ca",
  null
  
)

export default component.exports